import { hideBlockedPosts, ensureFilterButtons } from '~/frontend/filter.js'
import { removeDuplicates } from '~/frontend/util.js'

let loadingMore = false;
let endReached = false;


const lastPostUrl = () => document.querySelector('body > #Content > table > tbody > tr:last-child > td:first-child > a').getAttribute('href');

export const loadMore = async (entries, observer) => {
  if (loadingMore || endReached) return;
  if (!entries[0].isIntersecting) return;

  try {
    loadingMore = true;

    const response = await fetch('/?after=' + lastPostUrl());

    if (response.ok) {
      const html = await response.text();

      if (html.indexOf('<tr') === -1) {
        loadingMore = false;
        endReached = true;
        return;
      }

      const tbody = document.querySelector('body > #Content > table > tbody');
      tbody.insertAdjacentHTML('beforeend', html);

      removeDuplicates();
      hideBlockedPosts();
      ensureFilterButtons();
    }

  } catch (e) {
    console.error(e);
  }

  loadingMore = false;
};
